export const MEDIA_TYPES = [
  {
    label: 'All Media Types',
    value: 'ALL',
  },
  {
    label: 'Apps',
    value: 'Apps',
  },
  {
    label: 'Podcasts',
    value: 'Podcasts',
  },
  {
    label: 'Videos',
    value: 'Videos',
  },
  {
    label: 'Articles',
    value: 'Articles',
  },
  {
    label: 'Books',
    value: 'Books',
  },
  {
    label: 'Organizations',
    value: 'Organizations',
  },
];

export const ALL_APPROACHES = {
  label: 'All Approaches',
  value: 'ALL',
};
